import { ChangeEvent, useState } from "react";

export default function useCheckbox(machinesLength: number) {
  const [checkedItems, setCheckedItems] = useState<boolean[]>(
    new Array(machinesLength).fill(false)
  );

  const handleCheckboxChange = (
    index: number,
    event: ChangeEvent<HTMLInputElement>
  ) => {
    const updatedCheckedItems = [...checkedItems];
    updatedCheckedItems[index] = event.target.checked;
    setCheckedItems(updatedCheckedItems);
  };

  const handleParentCheckboxChange = (event: ChangeEvent<HTMLInputElement>) => {
    const isChecked = event.target.checked;
    setCheckedItems(new Array(machinesLength).fill(isChecked));
  };

  const resetCheckboxes = () => {
    setCheckedItems(new Array(machinesLength).fill(false));
  };

  return {
    checkedItems,
    setCheckedItems,
    handleCheckboxChange,
    handleParentCheckboxChange,
    resetCheckboxes,
  };
}
